module.exports = __webpack_public_path__ + "img/DSC_1919.51be9968.JPG";